import { runDemo } from "../shared/demoRunner";
import { createPbrGlossyScene } from "./scene";

runDemo({ createScene: createPbrGlossyScene });
